import { SpModal } from 'components/discover/sgNews/SpModal';
import { useSPIntl } from 'hooks/useIntl';
import { FC, useCallback, useMemo, useState } from 'react';
import styled from 'styled-components';

const ThumbnailImg = styled.div<{ $backgroundImageUrl?: string }>`
  background-color: var(--bs-bg-lvl2);
  background-image: ${props => (props.$backgroundImageUrl ? `url(${props.$backgroundImageUrl})` : 'none')};
  min-height: 200px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;

const DetailImg = styled.img`
  max-height: 300px;
  object-fit: fill;
`;

interface SgNewsItemProps {
  image: string;
  name: string;
  description: string;
  content: string;
  creationDate: string;
  tags: string[];
}

export const SgNewsItem: FC<SgNewsItemProps> = ({ image, name, description, content, creationDate, tags }) => {
  const { formatDisplayedDate, formatMessage } = useSPIntl();

  const [modal, setModal] = useState<boolean>(false);

  const toggle = useCallback(() => setModal(!modal), [modal]);

  const allTags = useMemo(() => {
    if (!Array.isArray(tags)) {
      return '';
    }

    return tags
      .map(tag => {
        if (tag === null) {
          return 'null';
        }
        if (tag === undefined) {
          return 'undefined';
        }
        return `${tag}`;
      })
      .join(';');
  }, [tags]);

  return (
    <>
      <div className="card col-12" data-e2e="sgnews-item" data-tags={allTags}>
        <div className="row">
          <ThumbnailImg $backgroundImageUrl={image} className="card-header col col-md-4 my-2"></ThumbnailImg>
          <div className="card-body col col-md-8 px-0 pb-4 ps-md-4 my-2">
            <a className="text-primary" onClick={toggle} data-e2e="sgnews-item-title">
              <h2>{name}</h2>
            </a>
            <p
              dangerouslySetInnerHTML={{ __html: description }}
              className="text-large my-2"
              data-e2e="sgnews-item-description"
            />
            <span className="text-secondary" data-e2e="sgnews-item-creation-date">
              {`${formatMessage({
                id: 'discover.news.published.on',
                defaultMessage: 'Published on',
              })} ${formatDisplayedDate(creationDate)}`}
            </span>
          </div>
        </div>
      </div>
      <SpModal isOpened={modal} toggleOpen={toggle} size="lg">
        <div className="modal-content">
          <div className="modal-header" onClick={toggle}>
            <h3 className="modal-title" data-e2e="sgnews-item-detail-title">
              {name}
            </h3>
            <button
              aria-label="Close"
              className="btn-close"
              data-dismiss="modal"
              type="button"
              onClick={toggle}
              data-e2e="sgnews-item-detail-close-icon"
            />
          </div>
          <div className="modal-body">
            <DetailImg src={image} />
            <div dangerouslySetInnerHTML={{ __html: content }} className="mt-5" data-e2e="sgnews-item-detail-content" />
            <div className="mt-3">
              <span className="text-secondary" data-e2e="sgnews-item-detail-creation-date">
                {`${formatMessage({
                  id: 'discover.news.published.on',
                  defaultMessage: 'Published on',
                })} ${formatDisplayedDate(creationDate)}`}
              </span>
            </div>
          </div>
          <div className="modal-footer">
            <button className='btn btn-primary btn-lg"' onClick={toggle} data-e2e="sgnews-item-detail-close-btn">
              {formatMessage({ id: 'close', defaultMessage: 'Close' })}
            </button>
          </div>
        </div>
      </SpModal>
    </>
  );
};
